export const calculatePricePerSqm = (spaAmount, project, unit) => {
  let pricePerSqm = 0;

  if (unit && unit.size > 0) {
    let sizeSqm = unit.size;
    if (project && project.sizeSuffix === 'square_feet') {
      sizeSqm = sizeSqm / 10.764;
    }
    pricePerSqm = (spaAmount / sizeSqm).toFixed(2);
  }

  return parseFloat(pricePerSqm);
};



// WEBPACK FOOTER //
// ./src/utils/price.js